import React from 'react';
import { Trans } from 'react-i18next';
import { SongInsights } from '../../Dashboard';
import { getStationNameList } from '../SmartInsightsCardContentHelper';

// 2. Peak Airplay card content logic
export const getPeakAirplayCardContent = (
  songInsights: SongInsights,
  groupName: string,
  isHovering = false
): React.ReactNode => {
  const peakAirplayData = songInsights?.songInsightsData?.peak_airplay;
  if (!peakAirplayData) return null;
  if (isHovering) {
    return <Trans i18nKey="PEAK_HOVER" components={{ bold: <strong /> }} />;
  }
  const groups =
    peakAirplayData.groups[groupName as keyof typeof peakAirplayData];

  if (groups) {
    const { items, last } = getStationNameList(
      groups.stations.map((s) => s.name)
    );
    if (groups.total < 4) {
      const groupKey =
        groups.total === 1
          ? `PEAK_${groupName}_SINGLE`
          : `PEAK_${groupName}_SOME`;
      return (
        <Trans
          i18nKey={groupKey}
          values={{
            station: items,
            lastStation: last,
          }}
          components={{ bold: <strong /> }}
        />
      );
    }
    if (groups.total >= 4) {
      const groupKey = `PEAK_${groupName}_MULTI`;
      return (
        <Trans
          i18nKey={groupKey}
          values={{
            stationlist: items,
            lastStation: last,
            number: groups.total - 3,
          }}
          components={{ bold: <strong /> }}
        />
      );
    }
  }
  return null;
};
